import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payments-gateway',
  templateUrl: './payments-gateway.component.html',
  styleUrls: ['./payments-gateway.component.scss']
})
export class PaymentsGatewayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
